import React, { useEffect, useState } from "react";
import { Box, Stack, Typography } from "@mui/material";
import i18n from "../../i18n-config";
import { CustomButton, SvgContainer } from "../../components";
import theme from "../../theme/theme";
import { FILTER } from "../../assets/icons";
import CorbeilleTable from "./component/CorbeilleTable";
import CorbeilleForm from "./component/CorbeilleForm";
import CorbeilleDetail from "./component/CorbeilleDetail";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/state";


function Corbeille() {
  const dispatch = useDispatch();

  const taches = useSelector((state: RootState) => Object.values(state.tache));
console.log(taches)
  const [formVisible, setFormVisible] = useState(false);

  const onCloseForm = () => {
    setFormVisible(false);
  };


  return (
    <Box sx={{ minHeight: "100vh", backgroundColor: "#F9F9F9" }} p={3} pt={6}>
      <Stack direction={"row"} justifyContent="space-between" mb={3}>
        <Typography fontSize={22} fontWeight="600">
          {i18n.t("corbeille")}
        </Typography>
        <Stack direction={"row"} spacing={2}>
          <CustomButton
            title={i18n.t("filtrer_par")}
            rightComponent={
              <SvgContainer
                svg={FILTER}
                color={theme.colors.white}
                width={15}
              />
            }
            titleStyle={{ marginRight: 1 }}
            rootStyle={{ backgroundColor: theme.colors.black, height: 45 }}
          />
          <CustomButton
            title={i18n.t("mes_taches")}
            titleStyle={{ marginLeft: 1 }}
            rootStyle={{ backgroundColor: "#FF7900", height: 45 }}
          />
        </Stack>
      </Stack>
      <CorbeilleTable data={taches} />
      <CorbeilleForm open={formVisible} onClose={onCloseForm} />
      <CorbeilleDetail
        open={false}
        item={undefined}
        onClose={function (): void {
          throw new Error("Function not implemented.");
        }}
        isProvider={false}
        onEdit={function (item: any): void {
          throw new Error("Function not implemented.");
        }}
      />
    </Box>
  );
}

export default Corbeille;
